<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    :title="title"
    @close="close"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="标签ID" prop="name">
        <el-input v-model="form.tagId" disabled></el-input>
      </el-form-item>
      <el-form-item label="价格(菲律宾)" prop="price">
        <el-input v-model="form.price"></el-input>
      </el-form-item>
      <el-form-item label="价格(澳大利亚)" prop="ausPrice">
        <el-input v-model="form.ausPrice"></el-input>
      </el-form-item>
      <el-form-item label="价格(马来西亚)" prop="mysPrice">
        <el-input v-model="form.mysPrice"></el-input>
      </el-form-item>
      <el-form-item label="积分" prop="score">
        <el-input v-model="form.score"></el-input>
      </el-form-item>
      <el-form-item label="鉴定图片类型" prop="name">
        <el-input v-model="form.imageTypes" placeholder='Split by ","'></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      form: {
        tagId: "",
        imageTypes: "",
        price: 0,
        ausPrice: 0,
        mysPrice: 0,
        score: 0,
      },
      rules: {},
      dialogFormVisible: false,
      loading: false,

      tags: [],
    };
  },
  methods: {
    async show(row) {
      this.title = "配置";
      this.form.tagId = row.id;
      this.form.imageTypes = "";
      this.form.price = row.appriaseConfig.price;
      this.form.ausPrice = row.appriaseConfig.ausPrice;
      this.form.mysPrice = row.appriaseConfig.mysPrice;
      this.form.score = row.appriaseConfig.score;

      if (row.appriaseConfig && row.appriaseConfig.imageTypes) {
        const imageTypeIds = [];
        for (let i = 0; i < row.appriaseConfig.imageTypes.length; i++) {
          const imageType = row.appriaseConfig.imageTypes[i];
          imageTypeIds.push(imageType.id);
        }
        this.form.imageTypes = imageTypeIds.join(",");
      }

      this.$forceUpdate();
      this.dialogFormVisible = true;
    },
    close() {
      this.$refs.formRef.resetFields();
      // this.form = {};
      this.dialogFormVisible = false;
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const url = "base:/api/admin/appraise-config/set";

          const params = {
            ...this.form,
          };

          // 固定为品牌标签
          params.type = 1;

          try {
            await this.axios.form(url, params);
            this.$message.success("保存成功");
            this.$emit("success");
            this.close();
          } catch (e) {
            this.$notify.error({ title: "错误", message: e.message || e });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
